import React, { useCallback, useEffect } from "react";
import { useTheme, CssBaseline, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useAppStore } from "../../stores/useAppStore";
import { useLocation } from "react-router-dom";
import Content from "./content/content";
import TopNavigation from "./topNavigation";
import Footer from "./footer/footer";
import { getUser } from "../../services/AAD_B2C.service";

const LayoutContainer = ({ userName: propUserName }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const appTitle = useAppStore(state => state.appTitle);
  const setAppTitle = useAppStore(state => state.setAppTitle);
  const authUser = getUser();

  const updateAppTitle = useCallback((pathname) => {
    if (pathname.startsWith('/news')) {
      setAppTitle(t('news.title'));
      return;
    }

    switch (pathname) {
      case "/":
        setAppTitle(t('dashboard.title'));
        break;
      case "/invoices":
        setAppTitle(t('invoices.title'));
        break;
      case "/contracts":
        setAppTitle(t('contracts.title'));
        break;
      case "/changes":
        setAppTitle(t('changes.title'));
        break;
      case "/profile":
        setAppTitle(t('profile.title'));
        break;
      case "/consumptions":
        setAppTitle(t('consumptions.title'));
        break;
      case "/dataholder":
        setAppTitle(t('dataholder.title'));
        break;
      case "/alerts":
        setAppTitle(t('alerts.title'));
        break;
      case "/reports":
        setAppTitle(t('reports.title'));
        break;
      case "/help":
        setAppTitle(t('ayuda.title'));
        break;
      default:
        setAppTitle("");
        break;
    }
  }, [setAppTitle, t]);

  useEffect(() => {
    updateAppTitle(location.pathname);
  }, [location.pathname, updateAppTitle]);

  const styles = {
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: theme.palette.background.default,
    },
  };

  const displayUserName = propUserName || authUser?.email;

  return (
    <Box sx={styles.root}>
      <CssBaseline />
      <TopNavigation userName={displayUserName} />
      <Content />
      <Footer />
    </Box>
  );
};

export default LayoutContainer;
